import React, { useState, useEffect } from "react";
import { Modal, Form, Row, Col, Input, Button, message } from "antd";
import { convertIntoFormData } from "../../utils/utils";
import axiosInstance from "../../utils/axiosInstance";

export default function ClauseFormModal({ visible, onCancel, onSuccess, isSaveAs = false, recordData = null, companyId, }) {
    const [form] = Form.useForm();
    const [isFormLoading, setIsFormLoading] = useState(false);
    const [fileName, setFilename] = useState();

    useEffect(() => {
        if (recordData) {
            form.setFieldsValue({
                clause_name: recordData.clause_name,
                description: recordData.description,
                serial_number: recordData.serial_number,
                implementation_instances: recordData.implementation_instances,
            });
        } else {
            form.resetFields();
        }
    }, [recordData, form]);

    const handleOk = async () => {
        try {
            await form.validateFields();
            const values = form.getFieldsValue();
            setIsFormLoading(true);

            let apiUrl = isSaveAs
                ? `/contract/save-as-clause/`
                : `/contract/clause/`;

            const payload = {
                ...values,
                clause_file: fileName || undefined,
            };

            if (isSaveAs) {
                payload.master_clause_id = recordData?.master_clause_id || "";
            } else {
                payload.company_id = companyId;
            }

            const fromData = convertIntoFormData(payload);
            const response = await axiosInstance.post(apiUrl, fromData);

            if (response.status === 200) {
                message.success(response.data.message);
                onSuccess();
                form.resetFields();
            } else {
                message.error(response.data.message || "Something went wrong");
            }
            setIsFormLoading(false);
        } catch (error) {
            console.error(error);
            setIsFormLoading(false);
            onCancel();
            form.resetFields();
        }
    };

    return (
        <Modal
            open={visible}
            title={isSaveAs ? "Save Clause As" : "Add Clause"}
            onOk={handleOk}
            onCancel={() => {
                form.resetFields();
                onCancel();
            }}
            okText={isSaveAs ? "Save" : "Submit"}
            okButtonProps={{ loading: isFormLoading }}
        >
            <Form form={form} layout="vertical">
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Clause Name"
                            name="clause_name"
                            rules={[{ required: true, message: "This field is required!" }]}
                        >
                            <Input placeholder="Enter Clause Name" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Implementation Instances"
                            name="implementation_instances"
                            rules={[{ required: true, message: "This field is required!" }]}
                        >
                            <Input placeholder="Enter Implementation Instances" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Description"
                            name="description"
                            rules={[{ required: true, message: "This field is required!" }]}
                        >
                            <Input placeholder="Enter Description" />
                        </Form.Item>
                    </Col>
                    {!isSaveAs && (
                        <Col span={12}>
                            <Form.Item
                                label="Select File"
                                name="clause_file"
                                valuePropName="fileList"
                                getValueFromEvent={(e) => e.target.files}
                                rules={[{ required: true, message: "This field is required" }]}
                            >
                                <Input
                                    type="file"
                                    accept=".doc, .docx"
                                    onChange={(e) => setFilename(e.target.files[0])}
                                />
                            </Form.Item>
                        </Col>
                    )}
                    <Col span={12}>
                        <Form.Item
                            label="Serial Number"
                            name="serial_number"
                            initialValue={recordData?.serial_number}
                        >
                            <Input placeholder="Enter Serial Number" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}
